import { Color, Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import {
  AddDataSourceResponse,
  FormNewDataSource,
  FormNewDataSourceData,
  FormNewDataSourceDataS3,
  NewDataSourceType,
} from 'dashboard/forms/FormNewDataSource';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import {
  GoogleSheetsFilesResponse,
  S3Config,
  S3Object,
} from 'dashboard/models/external-integration';

const StyledModalContainer = styled(ModalContainer)`
  padding: 0;
`;

const StyledModalHeader = styled(ModalHeader)`
  padding: ${Spacing[4]};
  border-bottom: 1px solid ${Color.CoreSlate100};
`;

const StyledModalBody = styled(ModalBody)`
  padding: 0;
`;

interface AddDataSourceModalProps {
  getAllGoogleSheets: (code: string, redirectUrl: string) => Promise<GoogleSheetsFilesResponse>;
  handleClose: () => void;
  handleSubmitAddDataSource: (values: FormNewDataSourceData) => Promise<AddDataSourceResponse>;
  s3Config: S3Config | null;
  handleListS3Objects: (values: FormNewDataSourceDataS3) => Promise<S3Object[]>;
  dataSourceType?: NewDataSourceType | null;
}

const AddDataSourceModal = ({
  getAllGoogleSheets,
  handleClose,
  handleSubmitAddDataSource,
  s3Config,
  handleListS3Objects,
  dataSourceType,
}: AddDataSourceModalProps) => {
  return (
    <StyledModalContainer>
      <StyledModalHeader data-test='add-data-source-modal__header' onClose={handleClose}>
        New data source
      </StyledModalHeader>
      <StyledModalBody>
        <FormNewDataSource
          onSubmit={handleSubmitAddDataSource}
          s3Config={s3Config}
          handleListS3Objects={handleListS3Objects}
          getAllGoogleSheets={getAllGoogleSheets}
          dataSourceType={dataSourceType}
        />
      </StyledModalBody>
    </StyledModalContainer>
  );
};

export default AddDataSourceModal;
